/*
 * Доступ к Kubernetes API кластера платформы через прокси плагина Kubernetes (бэкенд ходит в
 * k8s-proxy GitLab Agent). Кластер должен быть описан для плагина (модуль argocdInstances
 * бэкенда собирает список из агентов проекта viva/clusters).
 */
import { KubernetesApi } from '@backstage/plugin-kubernetes';

/** GET по пути API кластера (например /api/v1/nodes), ответ — распарсенный JSON. */
export type ClusterGet = <T>(path: string) => Promise<T>;

/** Клиент API кластера clusterName; undefined — кластер не задан или плагину не известен. */
export const clusterClient = async (
  api: KubernetesApi,
  clusterName: string | undefined,
): Promise<ClusterGet | undefined> => {
  if (!clusterName) return undefined;
  const clusters = await api.getClusters();
  if (!clusters.some(c => c.name === clusterName)) return undefined;
  return async <T>(path: string): Promise<T> => {
    const res = await api.proxy({ clusterName, path });
    if (!res.ok) {
      throw new Error(`${path}: HTTP ${res.status} ${await res.text()}`);
    }
    return res.json();
  };
};

/** Текст заглушки, когда кластер не описан в плагине Kubernetes. */
export const CLUSTER_NOT_CONNECTED =
  'кластер не подключён к плагину Kubernetes (агент в проекте viva/clusters, user_access для группы viva)';
